module.exports = __webpack_public_path__ + "img/light-bulb.6f4ea187.svg";